import axios from "../axiosConfig"; // Adjust the import path accordingly

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
// const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const PartyWiseItemPriceService = {
  
  GetAllPartyWiseItemPrice: async (filter) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/GetAllPartyWiseItemPrice`;

    return await axios({
      method: "post",
      url: apiUrl,
      data: filter,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  GetPartyWiseItemPriceById: async (id) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/GetPartyWiseItemPriceById/${id}`;

    return await axios({
      method: "get",
      url: apiUrl,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  CreatePartyWiseItemPrice: async (data) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/CreatePartyWiseItemPrice`;

    return await axios({
      method: "post",
      url: apiUrl,
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  UpdatePartyWiseItemPrice: async (data, partyId) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/UpdatePartyWiseItemPrice/${partyId}`;

    return await axios({
      method: "put",
      url: apiUrl,
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  DeletePartyWiseItemPrice: async (partyId) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/DeletePartyWiseItemPrice/${partyId}`;

    return await axios({
      method: "delete",
      url: apiUrl,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  UpdateCategoryWiseItemPrice: async (data) => {
    const apiUrl = `${WebApiUrl}/api/PartyWiseItemPrice/UpdateCategoryWiseItemPrice`;

    return await axios({
      method: "post",
      url: apiUrl,
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};

export default PartyWiseItemPriceService;
